export const INIT_SCALE = 0.005;
export const INIT_SCALE_PREV_DETAIL = 0.011;
export const PREVIEW_MAX_SIZE = 400;
export const PREVIEW_OFFSET = 12;
export const PREVIEW_VIEWPORT_PADDING = 8;
export const PREVIEW_FIT_PADDING = 0.92;
const PREVIEW_MIN_SIDE = 80;

export const getPreviewBoxSize = (length, width) => {
    const detailLength = Math.max(Number(length) || 1, 0.001);
    const detailWidth = Math.max(Number(width) || 1, 0.001);
    const aspect = detailLength / detailWidth;

    let boxWidth;
    let boxHeight;

    if (aspect >= 1) {
        boxWidth = PREVIEW_MAX_SIZE;
        boxHeight = PREVIEW_MAX_SIZE / aspect;
    } else {
        boxHeight = PREVIEW_MAX_SIZE;
        boxWidth = PREVIEW_MAX_SIZE * aspect;
    }

    if (boxWidth < PREVIEW_MIN_SIDE) {
        const factor = PREVIEW_MIN_SIDE / boxWidth;
        boxWidth = PREVIEW_MIN_SIDE;
        boxHeight = Math.min(PREVIEW_MAX_SIZE, boxHeight * factor);
    } else if (boxHeight < PREVIEW_MIN_SIDE) {
        const factor = PREVIEW_MIN_SIDE / boxHeight;
        boxHeight = PREVIEW_MIN_SIDE;
        boxWidth = Math.min(PREVIEW_MAX_SIZE, boxWidth * factor);
    }

    return {
        boxWidth: Math.round(boxWidth),
        boxHeight: Math.round(boxHeight),
    };
};

export const shouldOpenPreviewOnLeft = (anchorEl, length, width) => {
    if (!anchorEl?.getBoundingClientRect) {
        return false;
    }

    const {boxWidth} = getPreviewBoxSize(length, width);
    const requiredWidth = boxWidth + PREVIEW_OFFSET + PREVIEW_VIEWPORT_PADDING;
    const {right, left} = anchorEl.getBoundingClientRect();
    const spaceRight = window.innerWidth - right;
    const spaceLeft = left;

    if (spaceRight >= requiredWidth) {
        return false;
    }

    return spaceLeft >= requiredWidth || spaceLeft > spaceRight;
};

export const calcNewScale = (canvas, detailData, prevDetail, inExport) => {
    const {clientHeight, clientWidth} = canvas;
    const scale = inExport ? inExport : prevDetail ? INIT_SCALE_PREV_DETAIL : INIT_SCALE

    const lengthDetailRatio = clientWidth / detailData?.length
    const widthDetailRatio = clientHeight / detailData?.width

    return lengthDetailRatio < widthDetailRatio
        ? lengthDetailRatio * scale
        : widthDetailRatio * scale;
}
